import SupervisorHome from '../pages/supervisorHome/';
import { other } from './supervisor/other';
// import { productions } from './supervisor/production';
import { supervisor } from './supervisor/supervisor';

export const IndexSupervisor = [
  {
    path: 'home',
    element: <SupervisorHome />,
  },
  ...supervisor,
  ...other,
  // ...productions,
];
